import { useEffect, useCallback } from 'react';
import { selectors, getAll, addItem, updateItem, deleteItem } from '../../../redux/companyAddresses';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

export default function useCompanyAddress() {
    const dispatch = useDispatch();
    const identity = useSelector(state => state.identity);
    const reduxState = useSelector(state => state.companyAddresses);
    const items = selectors.selectAll(reduxState);
    const loading = reduxState.loading;

    useEffect(() => {
        dispatch(getAll(identity.company_id));
    }, [dispatch, identity.company_id]);

    const save = useCallback((item) => {
        const updateCall = async () => {
            if (item.address_id) {
                await dispatch(updateItem({ id: item.address_id, ...item }));
            } else {
                await dispatch(addItem({ ...item, parent_type: 'TENANT', parent_id: identity.company_id }));
            }
            toast.success("Saved successfully");
        };

        updateCall();
    }, [dispatch, identity.company_id]);

    const remove = useCallback((item) => {
        const deleteCall = async () => {
            await dispatch(deleteItem(item));
            toast.success("Deleted successfully");
        };

        deleteCall();
    }, [dispatch]);

    return [
        items,
        loading,
        save,
        remove
    ];
};
